const savingsUtilizationMessages = {
  TITLE: 'Drug Saving Programs Summary',
  SUBTITLE:
    'Detailed analysis of prescription fills and savings across various programs',
  TOP_CARDS: {
    COST_SAVINGS: 'Cost Savings',
    PRESCRIPTION_FILLS: 'Prescription Fills',
    RX_COST: 'Rx Cost',
    PLAN_PAID: 'Plan Paid',
  },
};
export default savingsUtilizationMessages;
